import { ModelProperty } from './model-property';

export class DataDisplayUtils {
  public static getIcon(property: ModelProperty, data: any): string {
    if (property.formatter && property.formatter.type === 'icon') {
      return this.generateIcon(property, data);
    } else if (property.icon && property.showIconOnTable) {
      return property.icon;
    }
    return undefined;
  }

  private static generateIcon(property: ModelProperty, data: any): string {
    let icon;
    if (property.type === 'boolean') {
      icon =
        property.formatter.values[
          data[property.formatter.field] ? 'true' : 'false'
        ];
    } else {
      if (property.getPrimaryKey()) {
        const key = data[property.formatter.field][property.getPrimaryKey()];
        icon = property.formatter.values[key];
      } else {
        icon = property.formatter.values[data[property.formatter.field] + ''];
      }
    }
    return icon;
  }
}
